import '@polleverywhere/advisory-message'

export function clearFullpageMessages () {
  document.querySelectorAll('advisory-message.entrypoint-advisory').forEach(el => el.remove())
}

export function showFullpageMessage ({
  icon = 'warning',
  iconType = 'icon',
  iconSpin = false,
  subject = '',
  message = '',
  modifier = null,
  resolve = false,
  abort = false
} = {}) {
  clearFullpageMessages()

  const advisory = document.createElement('advisory-message')
  advisory.classList.add('entrypoint-advisory')
  if (modifier) {
    advisory.classList.add(`entrypoint-advisory--${modifier}`)
  }

  advisory.setAttribute('icon', icon)
  advisory.setAttribute('iconType', iconType)
  if (iconSpin) {
    advisory.setAttribute('spinIcon', true)
  }

  advisory.setAttribute('subject', subject)
  advisory.setAttribute('message', message)

  if (resolve) {
    advisory.setAttribute('resolutionLabel', resolve.label)
    advisory.addEventListener('resolve', resolve.handler)
  }

  if (abort) {
    advisory.setAttribute('abortLabel', abort.label)
    advisory.addEventListener('abort', abort.handler)
  }

  document.body.append(advisory)

  return advisory
}
